import { Button, Col, Row, Spinner } from 'react-bootstrap';
import React, { useEffect } from 'react';

import { IconType } from 'react-icons';
// eslint-disable-next-line
// @ts-ignore
import ReactStars from 'react-rating-stars-component';
import Select from 'react-select';
import SkillChip from '../SkillChip/SkillChip';
import styles from './SkillRatingList.module.css';
import { useState } from 'react';

type Skill = {
    id: number;
    name: string;
};

interface SkillRating {
    skill: Skill;
    rating: number;
}

interface SkillRatingsProps {
    title: string;
    skillTitle: string;
    skillSource: Skill[];
    selectedSkillRatings?: SkillRating[];
    isLoading?: boolean;
    Icon?: IconType;
    onSkillRatingsChanged?: (skillRatings: SkillRating[]) => void;
}

const SkillRatings: React.FC<SkillRatingsProps> = (props: SkillRatingsProps) => {
    const { Icon } = props;

    const [skillRatings, setSkillRatings] = useState<SkillRating[]>([]);
    const [selectedSkillOption, setSelectedSkillOption] = useState<any>(null);
    const [pendingRating, setPendingRating] = useState<number>(0);

    const selectedSkillIds = skillRatings.filter(x => x.skill.id).map(x => x.skill.id);
    const skillOptions = props.skillSource.filter(ss => !selectedSkillIds.includes(ss.id))
        .map((x: any) => ({
            value: x.id,
            label: x.name,
            ratingValue: 0,
        })).sort((a: any, b: any) => {
            return a.label > b.label && 1 || -1;
        });

    const handleOnClickRemove = (index: number) => {
        const newSkillRatings = [...skillRatings];
        newSkillRatings.splice(index, 1);
        setSkillRatings(newSkillRatings);

        if (props.onSkillRatingsChanged) {
            props.onSkillRatingsChanged(newSkillRatings);
        }
    };

    const onAddSkill = (): void => {
        if (!selectedSkillOption || pendingRating === 0) return;
        const newSkillRatings = [
            ...skillRatings,
            {
                skill: { id: parseInt(selectedSkillOption.value), name: selectedSkillOption.label },
                rating: pendingRating * 2,
            },
        ];
        setSkillRatings(newSkillRatings);
        setSelectedSkillOption(null);
        setPendingRating(0);
        if (props.onSkillRatingsChanged) {
            props.onSkillRatingsChanged(newSkillRatings);
        }
    };

    useEffect(() => {
        if (props.selectedSkillRatings && props.selectedSkillRatings.length > 0) {
            setSkillRatings(props.selectedSkillRatings);
        }
    }, [props.selectedSkillRatings]);

    return (
        <div>
            <Row>
                <Col>
                    <h2 className={styles.title}>
                        {Icon && <>
                            <Icon size="23" className={styles.titleIcon} />&nbsp;&nbsp;
                        </>}
                        {props.title}
                    </h2>
                </Col>
                <Col className="text-right">
                    <p className={styles.itemCount}>
                        {skillRatings.length} {skillRatings.length === 1 ? 'item' : 'items'}
                    </p>
                </Col>
            </Row>
            <Row className="align-items-center mt-2 flex-nowrap">
                <Col className="mb-2">
                    <Select
                        className="react-select"
                        options={skillOptions}
                        placeholder={`Search ${props.skillTitle}...`}
                        value={selectedSkillOption}
                        onChange={(option: any) => {
                            setSelectedSkillOption(option);
                            setPendingRating(0);
                        }}
                        isClearable
                    />
                </Col>
                {selectedSkillOption && (
                    <>
                        <Col xs="auto" className="mb-2">
                            <ReactStars
                                count={5}
                                size={20}
                                isHalf={true}
                                activeColor="#f4b331"
                                value={pendingRating}
                                key={selectedSkillOption.value}
                                onChange={(value: any) => setPendingRating(value)}
                            />
                        </Col>
                        <Col xs="auto" className="mb-2">
                            <Button
                                variant="outline-dark"
                                size="sm"
                                onClick={onAddSkill}
                                disabled={pendingRating === 0}
                            >
                                Add
                            </Button>
                        </Col>
                    </>
                )}
            </Row>
            {!props.isLoading && (
                <div className={styles.skillRatingItems}>
                    <Row>
                        <Col className={styles.skillRatingItemsWrapper}>
                            {skillRatings.map((skillRating, index) => (
                                <SkillChip
                                    key={index}
                                    label={skillRating.skill?.name}
                                    rating={skillRating.rating}
                                    onDeleteButtonClick={(): void => handleOnClickRemove(index)}
                                />
                            ))}
                        </Col>
                    </Row>
                </div>
            )}
            {props.isLoading &&
                <Row>
                    <Col className="text-center my-5">
                        <Spinner animation="border" className="me-5 text-center" />
                    </Col>
                </Row>
            }
        </div>
    );
};

export default SkillRatings;